function truncateString(value, maxLength) {
  return value.length > maxLength ? value.slice(0, maxLength) + ' ...' : value;
}

export { truncateString };
